<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch center; align-items: stretch; height:100%">
  <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch flex-start; align-items: stretch; flex: 1 1 100%; max-width: 50%;">
    <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 5%">
    </div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
      <mat-toolbar color="primary">
        <mat-card-title>Change Your Password</mat-card-title>
      </mat-toolbar>
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-card appearance="outlined" style="flex-direction: column; box-sizing: border-box; display: flex;">
          <mat-card-content>
            <form [formGroup]="managePasswordForm" (ngSubmit)="onSubmit()">
              <mat-form-field class="full-width password">
                <mat-label>Current Password</mat-label>
                <input matInput placeholder="Current Password" [type]="hidePassword ? 'password' : 'text'" formControlName="password" required>
                <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                <mat-error *ngIf="managePasswordForm.controls['password'].invalid">
                  <p *ngIf="managePasswordForm.controls['password'].errors.errorMessage">{{errorMessage}}</p>
                </mat-error>
              </mat-form-field>
              <mat-form-field class="full-width password">
                <mat-label>New Password</mat-label>
                <input matInput placeholder="New Password" [type]="hideNewPassword ? 'password' : 'text'" formControlName="newPassword" required>
                <mat-icon matSuffix (click)="hideNewPassword = !hideNewPassword">{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </mat-form-field>
              <mat-form-field class="full-width password">
                <mat-label>Confirm New Password</mat-label>
                <input matInput placeholder="Confirm New Password" [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword" required>
                <mat-icon matSuffix (click)="hideConfirmPassword = !hideConfirmPassword">{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </mat-form-field>
            </form>
            <lex-manage-password-requirements [newPasswordControl]="managePasswordForm.get('newPassword')"
                                              [confirmPasswordControl]="managePasswordForm.get('confirmPassword')"
                                              [(passwordRequirementMet)]="passwordRequirementMet"></lex-manage-password-requirements>
          </mat-card-content>
          <mat-card-actions>
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center;">
              <button id="update" mat-raised-button color="primary" type="submit" (click)="onSubmit()" [disabled]="!passwordRequirementMet">Change Password</button>
              <button id="cancel" mat-button color="secondary" type="button" (click)="onCancel()">Cancel</button>
            </div>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
    <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 5%">
    </div>
  </div>
</div>